module.exports = __webpack_public_path__ + "img/close-menu.17486961.png";